export default "__VITE_ASSET__83281d59__"